class CurrencyService {
    constructor() {
        if (!CurrencyService.instance) {
            this._selectedCurrency = 'LKR';
            this._rates = {
                'USD': { 'LKR': 360.0, 'USD': 1.0 },
                'LKR': { 'LKR': 1.0, 'USD': 1 / 360.0 },
            };
            this._currencyIdMap = {
                1: 'USD',
                4: 'LKR',
            };
            CurrencyService.instance = this;
        }

        return CurrencyService.instance;
    }

    get selectedCurrency() {
        return this._selectedCurrency;
    }

    set selectedCurrency(currencyCode) {
        if (this._rates[currencyCode]) {
            this._selectedCurrency = currencyCode;
            localStorage.setItem('selectedCurrency', currencyCode);
            window.dispatchEvent(new CustomEvent('currencyUpdate', { detail: currencyCode }));
        } else {
            console.warn(`Currency code ${currencyCode} is not supported.`);
        }
    }

    getCurrencyFromId(id) {
        return this._currencyIdMap[id] || 'LKR';
    }

    getCurrencySymbol(currencyCode) {
        switch (currencyCode) {
            case 'USD':
                return '$';
            case 'LKR':
                return 'Rs';
            default:
                return currencyCode;
        }
    }

    convert(amount, { fromCurrency }) {
        const rate = this._rates[fromCurrency]?.[this._selectedCurrency];
        if (rate) {
            return amount * rate;
        }
        console.warn(`Conversion from ${fromCurrency} to ${this._selectedCurrency} is not available. Returning original amount.`);
        return amount;
    }
}

const instance = new CurrencyService();
export default instance;
